<template>
  <modal-UI
    title="Деталі повідомлення"
    :visible="visible"
    @close="$emit('close')"
  >
    <v-row no-gutters align="center" style="margin-top: 20px">
      <div style="width: 135px" class="item-name">Ім’я:</div>
      <div class="item-text">
        {{ message.name }}
      </div>
    </v-row>
    <v-row no-gutters align="center" style="margin-top: 20px">
      <div style="width: 135px" class="item-name">Email:</div>
      <div class="item-text">{{ message.email }}</div>
    </v-row>
    <v-row no-gutters align="center" style="margin-top: 20px">
      <div style="width: 135px" class="item-name">Телефон:</div>
      <div class="item-text">
        <a :href="`tel:${message?.phone}`" style="text-decoration: none">
          <span class="tableItem">{{
            message?.phone | VMask("+## ### ## ## ## ##")
          }}</span>
        </a>
      </div>
    </v-row>
    <v-row no-gutters style="margin-top: 20px">
      <div style="width: 135px" class="item-name">Повідомлення:</div>
      <v-col class="px-0 py-0">
        <div class="item-text">{{ message.user_message }}</div>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" style="margin-top: 20px">
      <div style="width: 135px" class="item-name">Дата створення:</div>
      <div class="item-text">
        {{
          new Date(message.created_at).toLocaleDateString("uk-UA", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        }}
      </div>
    </v-row>
    <div
      style="width: 135px; font-weight: 400; margin-top: 20px"
      class="item-name"
    >
      Статус
    </div>
    <v-autocomplete
      outlined
      dense
      style="margin-top: 7px"
      :items="Object.values(statusOptions)"
      :item-text="'text'"
      :item-value="'value'"
      v-model="message.status"
    />
    <v-row no-gutters justify="end">
      <v-btn
        @click="$emit('close')"
        color="#E2E8F0"
        outlined
        style="text-transform: none; border-radius: 6px"
      >
        <span
          style="
            color: #1976d2 !important;
            color: #1976d2;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 18px;
          "
          >Закрити</span
        >
      </v-btn>
    </v-row>
  </modal-UI>
</template>

<script>
import ModalUI from "../../UI/Modals/modalUI.vue";
import feedbackService from "../../../requests/Admin/feedbackService";
export default {
  components: { ModalUI },
  data: () => ({}),
  props: {
    visible: {
      require: true,
    },
    message: {
      require: true,
    },
    statusOptions: {
      require: true,
    },
  },
  methods: {
    async updateStatus() {
      const form = new FormData();
      form.append("status", this.message.status);
      await feedbackService.updateFeedback(this.message.id, form);
    },
  },
  watch: {
    message: {
      handler() {
        this.updateStatus();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.item-name {
  color: #020817;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
}
.item-text {
  color: #3e3e3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}
</style>